<template lang="html">
<div>
    <div class="album-list">
         <div class="album-item" v-for="(item,inx) in dataList" :key="inx" @click="goInner(item)">
               <div class="imgs" @click="goInner(item)">
                     <img :src="item.coverImage || item.catalog" alt="">
               </div>
               <div class="item-content">
                   <div class="item-name"><b>{{item.title || item.firstTitle}}</b><b class="audition" v-show="item.audition==1">（可试听）</b></div>
                    <div class="item-text">
                         <span class="itext" v-if="item.speed">{{item.speed}}</span>
                         <span class="itext" v-if="item.publish">{{item.publish}}</span>
                         <span class="itext" v-if="item.publishYears">{{item.publishYears}}</span>
                    </div>
               </div>
               <div class="iconsGp" v-if="iconType==1">
                    <van-icon class="icon" class-prefix="iconfont" name="more" />
               </div>
               <div v-else class="iconsGp" @click.stop="unCollect(item)" >
                    <van-icon class="icon" class-prefix="iconfont" name="uncollect" />
               </div>

         </div>
    </div>

</div>
</template>

<script>
export default {
     props:['listDat','listType','iconType'],  //  list 类型  1：专辑，2：单曲   icon 类型  1：常规，2：取消收藏
     watch:{
          listDat:function(newDat){
              this.dataList = newDat;
          }
     },
     data(){
          return {
              dataList:[],
          }
     },
     methods:{
          goInner:function(e){
             if(this.listType == 1){
                 this.push({
                      path:'album',
                      query:{
                          iab:e.albumId
                      }
                 });
             }else{
                 this.push({
                      path:'song',
                      query:{
                          iab:e.albumId,
                          icd:e.singleId
                      }
                 });
             }
          },
          unCollect:function(e){
              this.$emit('unCollect',e);
          }
     }
}
</script>

<style lang="css" scoped>

/* 列表 */

.album-item{
    padding: 10px 0;
    margin-left: 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #efefef;
    position: relative;
}

.album-item:last-child{
   border-bottom: none;
}

.album-item .imgs{
    width: 75px;
    height: 75px;
    border-radius: 6px;
    overflow: hidden;
    background: #efefef;
}

.album-item .imgs img{
    width: 75px;
    height: 75px;
}

.album-item .item-content{
    margin-left: 10px;
    flex-grow: 1;
    text-align: left;
}

.album-item .item-content .item-name{
    font-size: 15px;
    font-weight: 400;
    overflow: hidden;
}
.album-item .item-content .item-name b:nth-child(1){
    display: block;
    max-width: 150px;
    height: 20px;
    overflow: hidden;
    float: left;
    font-weight: normal;
}
.album-item .item-content .item-text{
    margin-top: 10px;
}

.album-item .item-content .item-text span{
   color: #999999;
   margin-right: 12px;
   font-size: 13px;
}

.album-item .iconsGp{
    width: 45px;
    height: 60px;
    padding-right: 10px;
    text-align: right;
}

.album-item .iconsGp .icon{
    font-size: 24px;
    line-height: 60px;
    color: #999999;
}

.audition{
    display: block;
    font-size: 12px;
    color: rgb(168, 45, 45);
    font-weight: normal;
    padding-top: 2px;
}
</style>
